import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import {
  canAccessImsPlatform,
  canAccessVmsPlatform,
  getImsDefaultLandingPath,
  getVmsDefaultLandingPath,
} from '../utils/vmsRole';

/** Blocks IMS shell when user is VMS-only. */
export function ImsPlatformGuard({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return null;
  if (user && !canAccessImsPlatform(user)) {
    return <Navigate to={getVmsDefaultLandingPath(user)} state={{ from: location }} replace />;
  }
  return <>{children}</>;
}

/** Blocks VMS shell when user is IMS-only. */
export function VmsPlatformGuard({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return null;
  if (user && !canAccessVmsPlatform(user)) {
    return <Navigate to={getImsDefaultLandingPath(user)} state={{ from: location }} replace />;
  }
  return <>{children}</>;
}
